import Head from 'next/head'
import { sanityClient } from '@bww/beke-lib/sanity-client'
import PageHeaderBanner, { HeaderTextBlock } from '@bww/beke-ui/PageHeader'
import ProcessContent from '@bww/beke-ui/OurProcess'
import YourDreamCTA from '@bww/beke-ui/YourDreamCTA'

export default function OurProcessPage({ steps }) {
  return (
    <>
      <Head>
        <title>How to get the perfect bathroom with Bathroom Elegance</title>
        <meta
          name="description"
          content="About Bathroom Elegance's integrated design and supply service."
        />
        <style>{`
          html { scroll-padding-top: 78px !important; }
          @media (min-width: 960px) {
            html { scroll-padding-top: 118px !important; }
          }
        `}</style>
      </Head>
      <PageHeaderBanner
        title="Our Process"
        categoryTitle="About Bathroom Elegance"
      />
      <HeaderTextBlock>
        <h2 className="h2" style={{ color: 'var(--color-primary)' }}>
          Our simple guide to stunning results
        </h2>
        <p>
          With more than two decades of experience delivering bathroom projects,
          we've learned a lot about achieving amazing results and keeping
          projects running smoothly.
        </p>
      </HeaderTextBlock>
      <ProcessContent steps={steps} />
      <YourDreamCTA />
    </>
  )
}

export async function getStaticProps() {
  const { steps } = await sanityClient.fetch(
    `*[_id == "be-process"][0]{
      steps[]{
        title,
        "id": id.current,
        headline,
        description,
        image {
          ...,
          "lqip": asset->metadata.lqip,
        }
      }
    }`,
  )

  return {
    props: {
      steps,
    },
  }
}
